import React, { FunctionComponent, useEffect, useState } from 'react';
import styles from './Modal.module.scss';
import { Button, Dialog, Slide } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { _t } from 'app/utils/i18n';
import { DateFrom, HelpIcon, LockIcon } from 'app/assets/images/icons';
import { useModal } from 'app/context/Modal';
import ImageSlider from '../ImageSlider/ImageSlider';
import SelectInput from '../Form/Inputs/SelectInput';
import Loader from '../Loader';
import DatePicker from '../Form/Inputs/DatePicker';
import CheckBox from '../Form/Inputs/CheckBox/CheckBox';
import PopperComponent from '../Tables/Cells/PopperComponent/PopperComponent';
import TextInput from '../Form/Inputs/TextInput';
import ReactSelectAutocomplete from '../Form/Inputs/ReactSelectAutocomplete';
import CheckBoxInput from '../Form/CheckBoxInput';
import ConversationPopup from '../ConversationPopup';
import CollectSectionPopup from 'news/components/CollectSectionPopup';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const Modal: FunctionComponent = () => {
  const { hide, modal, setIsDisabled, isDisabled } = useModal();

  const {
    isAlternative,
    message,
    smallMessage,
    onCancel,
    onOk,
    status,
    onOkText,
    onCancelText,
    hideCancel,
    imageUrl,
    imageUrls,
    imageIndex,
    videoUrl,
    openLink,
    linkText,
    autoHide,
    withSelectInput,
    withSelectAutocomplete,
    withTextInput,
    unMountCb,
    notAuthorizeCb,
    withDate,
    checkboxCondition,
    withQuestionPopup,
    nonUseLoader,
    instaVideoUrl,
    instaMediaUrls,
    withCheckboxGroup,
    customStyle,
    withCollectSectionPopup,
  } = modal;
  const [selectedItem, setSelectedItem] = useState(
    withSelectInput?.options?.filter((i) => i?.default)?.[0] || null,
  );
  const [checkbox, setCheckbox] = useState(false);
  const [textValue, setTextValue] = useState('');
  const [textError, setTextError] = useState('');
  const [filters, setFilters] = useState<any>({});
  const [showLoader, setShowLoader] = useState(false);
  const showImageStyle =
    !!imageUrl ||
    !!videoUrl ||
    !!imageUrls ||
    !!instaVideoUrl ||
    !!instaMediaUrls;
  useEffect(() => {
    if (!selectedItem) {
      setSelectedItem(
        withSelectInput?.options?.filter((i) => i?.default)?.[0] || null,
      );
    }
    setFilters({});
    return () => {
      setTextError('');
      setShowLoader(false);
      setCheckbox(false);
      setSelectedItem(null);
      setFilters({});
      unMountCb?.();
    };
  }, [status, withSelectInput]);

  return (
    <Dialog
      open={!!status}
      TransitionComponent={Transition}
      keepMounted
      onClose={autoHide ? () => hide(notAuthorizeCb) : undefined}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      disableRestoreFocus
    >
      <div
        style={customStyle}
        className={`${styles.Modal} ${showImageStyle && styles.ImageStyle} ${
          isAlternative && styles.AlternativeStyle
        }
          ${
            withCollectSectionPopup !== undefined && styles.CollectSectionPopup
          } `}
        data-testid="modalContainer"
      >
        {videoUrl && <iframe src={videoUrl} width="740" height="510"></iframe>}
        {instaVideoUrl && (
          <video crossOrigin="anonymous" width="740" height="510" controls>
            <source src={instaVideoUrl} type="video/mp4"></source>
          </video>
        )}
        {imageUrl ? (
          <img src={imageUrl} />
        ) : imageUrls ? (
          <div className={styles.ImageSliderrContainer}>
            <ImageSlider imageIndex={imageIndex} imageUrls={imageUrls} />
          </div>
        ) : instaMediaUrls ? (
          <div className={styles.ImageSliderrContainer}>
            <ImageSlider imageIndex={imageIndex} imageUrls={instaMediaUrls} />
          </div>
        ) : (
          <>
            {withCollectSectionPopup !== undefined && (
              <CollectSectionPopup data={withCollectSectionPopup} />
            )}
            {isAlternative && <LockIcon />}
            {!!message && (
              <>
                <p className={styles.Modal_description}>{message}</p>
                <p className={styles.Modal_small_description}>{smallMessage}</p>
                {withSelectInput && (
                  <div
                    data-testid="globalModalSelectInputContainer"
                    className="mb-30"
                  >
                    {(withDate || withSelectInput.isReport) && (
                      <p className={styles.Label}>
                        {_t('reports:report_template')}
                      </p>
                    )}
                    <SelectInput
                      placeholder={withSelectInput?.placeholder}
                      icon={withSelectInput?.icon}
                      options={withSelectInput?.options}
                      value={selectedItem}
                      name={withSelectInput?.name}
                      onChange={(event) => {
                        setSelectedItem(event);
                        withSelectInput?.onChange?.(event);
                      }}
                      data-testid="combobox"
                    />
                  </div>
                )}
                {withDate && (
                  <>
                    <p className={styles.Label}>
                      {_t('reports:platforms_data')}
                    </p>
                    <div className={`${styles.DateInputsHolder} mb-30`}>
                      <DatePicker
                        placeholder={_t('basic:from')}
                        name="start_date"
                        onChange={(val) => {
                          setFilters((old: any) => ({
                            ...old,
                            start_date: val,
                          }));
                        }}
                        maxDate={new Date()}
                        icon={<DateFrom />}
                        value={filters?.start_date}
                      />
                      <DatePicker
                        placeholder={_t('basic:to')}
                        name="end_date"
                        onChange={(val) => {
                          setFilters((old: any) => ({ ...old, end_date: val }));
                        }}
                        minDate={filters?.start_date || new Date()}
                        value={filters?.end_date}
                      />
                    </div>
                  </>
                )}
                {checkboxCondition && (
                  <div className={styles.checkBoxMessage}>
                    <CheckBox
                      onChange={(val: any) => {
                        setCheckbox(val.target.checked);
                      }}
                      checked={checkbox}
                      htmlFor={''}
                    />
                    <span>{checkboxCondition}</span>
                    {withQuestionPopup && (
                      <span className="mt-10">
                        <PopperComponent icon={<HelpIcon />}>
                          <div>{_t('influencers:checking_report_time')}</div>
                        </PopperComponent>
                      </span>
                    )}
                  </div>
                )}
                {withSelectAutocomplete && (
                  <div
                    className={styles.ConfirmationPopup__Input}
                    data-testid="ConfirmationPopup__Input1"
                  >
                    <ReactSelectAutocomplete
                      moduleName={withSelectAutocomplete.autoCompleteModule}
                      placeholder={withSelectAutocomplete.placeholder}
                      onChange={(item) => {
                        withSelectAutocomplete.onChange?.(item);
                      }}
                      keyExtractor={withSelectAutocomplete.keyExtractor}
                      isMulti={withSelectAutocomplete.isMulti}
                      icon={withSelectAutocomplete.icon}
                    />
                  </div>
                )}
                {withTextInput && (
                  <div className="mb-30">
                    <TextInput
                      name={withTextInput.name}
                      onChange={(value: string) => {
                        if (
                          withTextInput?.isMandatory &&
                          (value.trim().length === 0 ||
                            value.trim().length === 1 ||
                            value.trim().length > 255)
                        ) {
                          setTextError(
                            value.trim().length === 1
                              ? _t('basic:name_validation_min')
                              : value.trim().length > 255
                                ? _t('basic:max_err_255')
                                : _t('basic:err_required'),
                          );
                        } else {
                          setTextError('');
                        }
                        setTextValue(value);
                        withTextInput.onChange?.(value);
                      }}
                      label={withTextInput.label}
                      required={withTextInput.isMandatory}
                      placeholder={withTextInput.placeholder}
                      error={textError}
                    ></TextInput>
                  </div>
                )}
                {withCheckboxGroup && (
                  <div className="mb-30">
                    <CheckBoxInput
                      name={withCheckboxGroup?.name}
                      options={withCheckboxGroup?.options}
                      label={withCheckboxGroup?.label}
                      value={false}
                      onChange={withCheckboxGroup?.onChange}
                    />
                  </div>
                )}
                <div className={styles.Modal_controls}>
                  {!isAlternative && (
                    <>
                      {onOk && (
                        <Button
                          disabled={
                            isDisabled ||
                            (withSelectInput?.disableOkUntilSelect &&
                              !selectedItem)
                          }
                          onClick={() => {
                            if (
                              withTextInput?.isMandatory &&
                              (textValue.trim().length === 0 ||
                                textValue.trim().length === 1 ||
                                textValue.trim().length > 255)
                            ) {
                              setTextError(
                                textValue.trim().length === 1
                                  ? _t('basic:name_validation_min')
                                  : textValue.trim().length > 255
                                    ? _t('basic:max_err_255')
                                    : _t('basic:err_required'),
                              );
                              return;
                            }
                            setIsDisabled(true);
                            onOk(selectedItem, filters, checkbox, textValue);
                            setTextValue('');
                            setSelectedItem(null);
                            !nonUseLoader && setShowLoader(true);
                            setTimeout(() => {
                              setIsDisabled(false);
                            }, 1500);
                          }}
                          className="main-btn"
                          data-testid="globalOkModalButton"
                        >
                          {showLoader && status ? (
                            <Loader smallSize />
                          ) : onOkText ? (
                            onOkText
                          ) : (
                            _t('yes')
                          )}
                        </Button>
                      )}
                      {!hideCancel && (
                        <span
                          onClick={
                            withSelectInput
                              ? () => setSelectedItem(null)
                              : undefined
                          }
                        >
                          <Button
                            disabled={isDisabled}
                            onClick={onCancel ? onCancel : hide}
                            className={`${onOk ? '' : 'main-btn'}`}
                            data-testid="globalCancelModalButton"
                          >
                            {onCancelText || _t('no')}
                          </Button>
                        </span>
                      )}
                    </>
                  )}
                </div>
                <div>
                  {openLink && (
                    <a href={openLink} target="_blank" rel="noreferrer">
                      {linkText}
                    </a>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </Dialog>
  );
};

export default Modal;
